import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { authResetApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import HQMark from "@/components/HQMark";

export default function ResetPasswordPage() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw1.length < 12) return toast.error("Password must be at least 12 characters");
    if (pw1 !== pw2) return toast.error("Passwords do not match");
    if (!token) return toast.error("This reset link is invalid");
    setLoading(true);
    try {
      await authResetApi.reset(token, pw1);
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full bg-[#0B0E14] text-white flex items-center justify-center px-6"
         data-testid="reset-password-page">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6">
        <div className="flex items-center gap-3 text-white mb-6">
          <HQMark size={36} />
          <span className="font-display text-base font-semibold tracking-tight">Alias HQ</span>
        </div>
        <div>
          <div className="text-eyebrow mb-3">Set a new password</div>
          <h2 className="font-display text-2xl font-semibold tracking-tight">Choose a strong password</h2>
          <p className="text-white/50 mt-2 text-sm">At least 12 characters. You'll be signed in afterwards.</p>
        </div>
        <div>
          <Label className="text-white/70 text-xs uppercase tracking-wider">New password</Label>
          <Input type="password" value={pw1} onChange={(e) => setPw1(e.target.value)}
                 data-testid="reset-pw1-input" required
                 className="mt-1.5 bg-white/5 border-white/10 text-white h-11" />
        </div>
        <div>
          <Label className="text-white/70 text-xs uppercase tracking-wider">Confirm password</Label>
          <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
                 data-testid="reset-pw2-input" required
                 className="mt-1.5 bg-white/5 border-white/10 text-white h-11" />
        </div>
        <Button type="submit" disabled={loading}
                className="w-full h-11 rounded-full bg-white text-black hover:bg-white/90 font-medium"
                data-testid="reset-submit-btn">
          {loading ? "Updating…" : "Update password"}
        </Button>
        <div className="text-center">
          <Link to="/login" className="text-xs text-white/50 hover:text-white underline underline-offset-4">
            Back to sign in
          </Link>
        </div>
      </form>
    </div>
  );
}
